import {Box, CloseIcon, styled, Modal} from '../../../ui-library';

export const ModalBox = styled(Modal)`
    direction: rtl;
    border: transparent;
`;


export const ImageBox = styled(Box)`
    overflow: hidden;
    position: relative;

`;


export const ExitIcon = styled(CloseIcon)`
    cursor: pointer;
    color: white;
    margin-left: -75px;
    margin-top: 32px;
    z-index: var(--layer-1st);
`;


export const GalleryBox = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    align-content: center;
    user-focus-pointer: none;
`;


export const CustomImage = styled('img')`
    border-radius: 10px;
    margin: 20px 102px 20px 43px;
    width: auto;
    height: calc(100vh - 40px);
    object-fit: contain;
    user-select: none;
`;


